import Flex from '@Components/Bases/Flex';
import { Chip } from '@mui/material';

type TagsProps = {
  value: string[];
  onDeleteTag: (subcommittees: string) => void;
  disabled?: boolean;
};

const Tags = ({ value = [], onDeleteTag, disabled }: TagsProps) => {
  return (
    <Flex gap={1} flexWrap={'wrap'}>
      {value.map((item) => (
        <Chip
          key={item}
          label={item}
          onDelete={disabled ? undefined : () => onDeleteTag(item)}
          sx={{
            '& .MuiChip-deleteIcon': {
              display: disabled ? 'none' : 'block',
            },
          }}
          disabled={disabled}
        />
      ))}
    </Flex>
  );
};

export default Tags;
